import {
  ApiAttribute,
  Endpoint,
  EndpointAttributes,
} from '@context/openapi/types';
import { ApiAttributeType } from '@components/ui/DynamicForm/DynamicForm';
import { FormDataWithEndpointId } from '@/lib/types';

export function base64EncodedFormData(
  attributes: EndpointAttributes,
  endpoint: Endpoint
): string {
  const result = new Map<string, string>();
  let endpointUrl = endpoint.url.replaceAll('{', '').replaceAll('}', '');

  function addToMap(attrs: ApiAttribute[], type?: ApiAttributeType) {
    for (const attr of attrs) {
      if (
        type === ApiAttributeType.QUERY &&
        attr.filter &&
        attr.value !== undefined &&
        attr.value !== ''
      ) {
        const mapKey = `${attr.key}[${attr.filter}]`;
        result.set(mapKey, String(attr.value));
      } else if (
        type === ApiAttributeType.PATH &&
        attr.value !== undefined &&
        attr.value !== ''
      ) {
        endpointUrl = endpointUrl?.replace(attr.key, String(attr.value));
      } else {
        if (attr.value !== undefined && attr.value !== '') {
          if (attr.arrayIndex !== undefined) {
            // current_key =  subscription_items[0].billing_cycles -- Key format used in form builder
            // expected_key = subscription_items[billing_cycles][0] -- Key format used in the sample requests
            const parentKey = attr.key.split('[')[0];
            const childKey = attr.key.split('.')[1];
            const arrayKey = `${parentKey}[${childKey}][${attr.arrayIndex}]`;
            result.set(arrayKey, String(attr.value));
          } else {
            result.set(attr.key, String(attr.value));
          }
        }
      }

      if (attr.child && attr.child.length > 0) {
        addToMap(attr.child, type);
      }
    }
  }

  addToMap(attributes.params);
  addToMap(attributes.queryParams, ApiAttributeType.QUERY);
  addToMap(attributes.pathParameters, ApiAttributeType.PATH);

  const formData: FormDataWithEndpointId = {
    endpointId: endpoint.id,
    desc: '',
    uri: endpointUrl ?? '',
    params: {
      map: Object.fromEntries(result),
    },
  };

  return btoa(JSON.stringify(formData));
}
